/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';
import {DrivingLevel} from "../model/DrivingLevel";

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class DrivingLevelsService {
  private drivingLevelurl;
  constructor(private http: HttpClient) {
    this.drivingLevelurl = inject(APP_CONFIG).baseUrl + '/api/drivingLevel';

  }

  getAllDrivingLevels (): Observable<DrivingLevel[]> {
    const url = `${this.drivingLevelurl}/all`;
    return this.http.get(url).pipe(
      map(response => response as DrivingLevel[] ));
  }

  addNew(newDrivingLevel: DrivingLevel): Observable<DrivingLevel> {
    const url = `${this.drivingLevelurl}`;
    return this.http.post(url, newDrivingLevel, httpOptions).pipe(
      map( newDrivingLevel => newDrivingLevel as DrivingLevel ));
  }

  updateTrainingCourse(drivingLevel: DrivingLevel): Observable<DrivingLevel> {
    var url = `${this.drivingLevelurl}/${drivingLevel.drivingLevelId}`;
    return this.http.put(url, drivingLevel, httpOptions).pipe(
      map( drivingLevel => drivingLevel as DrivingLevel ));
  }
}
